import {Element} from "../../../../../../pkg/slate.js";
import {ACTION_ITEM_CHIP_TYPE, MENTION_TYPE} from "../../utils/constants.js";
export const matchActionItemElements = (el) => {
  if (!Element.isElement(el))
    return false;
  return el.type === ACTION_ITEM_CHIP_TYPE || el.type === MENTION_TYPE && el.data.mentionType === "event-mention";
};
